import React, { useCallback, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IntroOverlay from "./components/intro/IntroOverlay";
import Layout from "./components/layout/Layout";
import { ToastProvider } from "./components/ui/Toast";
import HomePage from "./components/home/HomePage";
import ReservationPage from "./components/reservations/ReservationPage";
import ManageReservation from "./components/manage/ManageReservation";
import InfoPage from "./components/info/InfoPage";
import QRScanner from "./components/qr/QRScanner";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import { shouldPlayIntro } from "./lib/intro";
import { prefersReducedMotion, supportsWebAnimations } from "./lib/motion";

const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true };

// Decided once per page load: loading (or refreshing) the home route plays the intro, navigating there later does not.
const playsIntroOnLoad = () =>
  shouldPlayIntro({
    pathname: window.location.pathname,
    prefersReducedMotion: prefersReducedMotion(),
    canAnimate: supportsWebAnimations(),
  });

function App() {
  const [isIntroPlaying, setIntroPlaying] = useState(playsIntroOnLoad);
  const finishIntro = useCallback(() => setIntroPlaying(false), []);

  return (
    <Router future={ROUTER_FUTURE}>
      <ToastProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/reservations" element={<ReservationPage />} />
            <Route path="/manage" element={<ManageReservation />} />
            <Route path="/info" element={<InfoPage />} />
          </Route>
          <Route path="/scanqr" element={<QRScanner />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </ToastProvider>
      {isIntroPlaying && <IntroOverlay onFinish={finishIntro} />}
    </Router>
  );
}

export default App;
